import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh, faUndo } from '@fortawesome/pro-solid-svg-icons';

import { findNodesByComponentType, renderComponents, unmountComponents } from './content_editor/component_rendering';
import IFrame from 'components/iframe';
import { addStyleTagToHeader } from 'helpers/dom_helper';

class ContentEditor extends React.Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    header: PropTypes.object,
    overrides: PropTypes.object.isRequired,
    renderPreviewType: PropTypes.func.isRequired,
    stylesPath: PropTypes.string.isRequired,

    onAiInteraction: PropTypes.func,
    onOverridesChange: PropTypes.func.isRequired,
    onOverridesReset: PropTypes.func.isRequired
  }

  state = {
    highlightAll: false,
    updateCount: 0
  }

  componentNodesByType = {};

  componentDidUpdate(previousProps) {
    // When the content changes, increment the IFrame's key to remount it.
    // Without this, components will mount but will not trigger any of their
    // event handlers after the first rerender for reasons unknown.
    if (this.props.content !== previousProps.content) {
      this.setState(previousState => ({
        updateCount: previousState.updateCount + 1
      }));
    }
  }

  componentWillUnmount() {
    unmountComponents(this.componentNodesByType);
  }

  renderComponents() {
    renderComponents(this.componentNodesByType, () => this.props, () => this.state);
  }

  handleDocumentUpdate = (doc) => {
    unmountComponents(this.componentNodesByType);
    this.componentNodesByType = findNodesByComponentType(doc);
    this.renderComponents();
  }

  resetAllOverrides = () => {
    this.props.onOverridesReset(Object.keys(this.props.overrides), () => {
      this.renderComponents();
    });
  }

  toggleHighlightAll = () => {
    this.setState(
      previousState => ({ highlightAll: !previousState.highlightAll }),
      () => this.renderComponents()
    );
  }

  render() {
    return <React.Fragment>
      <div className="email-preview-toolbar">
        {this.props.renderPreviewType()}

        <div>
          {Object.keys(this.props.overrides).length === 0 ? null : (
            <button className="btn btn-sm btn-secondary" onClick={this.resetAllOverrides}>
              <FontAwesomeIcon icon={faUndo} />
              Reset All
            </button>
          )}

          <button className="btn btn-sm btn-secondary" onClick={this.toggleHighlightAll}>
            <FontAwesomeIcon icon={faTh} />
            {this.state.highlightAll ? 'Un-highlight' : 'Highlight'} Editable Elements
          </button>
        </div>
      </div>

      {this.props.header}

      <div className="text-center h-100 w-100">
        <IFrame
          content={addStyleTagToHeader(this.props.content, this.props.stylesPath)}
          key={this.state.updateCount}
          onDocumentUpdate={this.handleDocumentUpdate}
        />
      </div>
    </React.Fragment>;
  }
}

export default ContentEditor;
